export default __webpack_public_path__ + "static/media/black.3c837145.svg";